module.exports = __webpack_public_path__ + "static/media/capital.cf1d6cf4.svg";